export default __webpack_public_path__ + "static/media/video.52c18cb5.svg";